import { createVanIconComponent } from "./van"

const UserOutlined = createVanIconComponent("user-o")
export default UserOutlined
